import React from 'react';
import PropertyCreationForm from '../components/PropertyCreationForm';
import { Link } from 'react-router-dom';

const CreatePropertyPage = () => {
  return (
    <div className="min-h-screen bg-[#F4F2E9]">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4">
          <nav className="flex items-center justify-between h-20">
            <Link to="/host/dashboard" className="flex items-center gap-3">
              <div className="h-[30px] w-auto flex items-center justify-center flex-shrink-0"><img src="/logo.png" alt="Ariv" className="h-[30px] w-auto object-contain" /></div>
            </Link>
          </nav>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8">
        <PropertyCreationForm />
      </div>
    </div>
  );
};

export default CreatePropertyPage;
